import React, { Component } from "react";
import { Grid, Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import EmployeeDetailsModal from "./EmployeeDetailsModal.jsx";
import { fetchPendingEmployeesRequest, handleEmployeeApprovalRequest } from "../../api/employee";
import { getFullName } from "../../helpers/functions/employee";

class EmployeeApprovalList extends Component {

  state = {
    employees: null,
    error: null,
    showEmployeeModal: false,
    selectedEmployeeId: null
  };

  componentDidMount() {
    if (!this.state.employees)
      this.fetchEmployees()
  }

  fetchEmployees(){
    fetchPendingEmployeesRequest(
      result => this.setState({employees: result, error: null}),
      error => this.setState({error: error})
    )
  };

  approveEmployee = (id) => {
    const data = {
      status: "Approved"
    }

    handleEmployeeApprovalRequest(id, data,
      result => {
        this.fetchEmployees()
        this.setState({
          showEmployeeModal: false,
          selectedEmployeeId: null
        })
      },
      error => this.setState({error: error})
    );
  }

  rejectEmployee = (id) => {
    const data = {
      status: "Rejected"
    }
    
    handleEmployeeApprovalRequest(id, data,
      result => {
        this.fetchEmployees()
        this.setState({
          showEmployeeModal: false,
          selectedEmployeeId: null
        })
      },
      error => this.setState({error: error})
    );
  }

  openEmployeeModal = (id) => {
    this.setState({
      showEmployeeModal: true,
      selectedEmployeeId: id
    })
  }

  closeEmployeeModal = () => {
    this.setState({
      showEmployeeModal: false,
      selectedEmployeeId: null
    })
  }

  render() {

    const { employees } = this.state;
    const view = <Tooltip id="view_tooltip">Details</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Approve</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Reject</Tooltip>;

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Employees to Approve"
                category="List of Employees that require approval"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Employee Number</th>
                        <th>Full Name</th>
                        <th>Department</th>
                        <th>Position</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    {employees && employees.length > 0 
                        ? employees.map(employee => {
                          return (
                            <tr key={employee._id}>
                              <td>{employee.employeeNumber || 'N/A'}</td>
                              <td>{getFullName(employee) || 'N/A'}</td>
                              <td>{employee.department ? employee.department.departmentName : 'N/A'}</td>
                              <td>{employee.position ? employee.position.positionName : 'N/A'}</td>
                              <td className="td-actions text-right">
                                <OverlayTrigger placement="top" overlay={view}>
                                  <CustomButtom 
                                    bsStyle="info" 
                                    simple 
                                    type="button" 
                                    bsSize="xs"
                                    onClick={() => this.openEmployeeModal(employee._id)}
                                  >
                                    <i className="fa fa-eye" />
                                  </CustomButtom>
                                </OverlayTrigger>

                                <OverlayTrigger placement="top" overlay={edit}>
                                  <CustomButtom 
                                    bsStyle="success" 
                                    simple 
                                    type="button" 
                                    bsSize="xs"
                                    onClick={() => this.approveEmployee(employee._id)}
                                  >
                                    <i className="fa fa-check" />
                                  </CustomButtom>
                                </OverlayTrigger>

                                <OverlayTrigger placement="top" overlay={remove}>
                                  <CustomButtom 
                                    bsStyle="danger" 
                                    simple 
                                    type="button" 
                                    bsSize="xs"
                                    onClick={() => this.rejectEmployee(employee._id)}
                                  >
                                    <i className="fa fa-times" />
                                  </CustomButtom>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          )
                        })
                        : (
                          <tr>
                            <td colSpan='5'>There are no employees that need approval.</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
        <EmployeeDetailsModal
          showModal={this.state.showEmployeeModal}
          closeModal={this.closeEmployeeModal}
          id={this.state.selectedEmployeeId}
          approveEmployee={this.approveEmployee}
          rejectEmployee={this.rejectEmployee}
        />
      </div>
    );
  }
}

export default EmployeeApprovalList;
